import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { usePolicy } from 'dashboard/composables/usePolicy';

// Acesso às CHAMADAS. Exige:
//   • o módulo `astracall` habilitado (Super Admin), E
//   • poder receber — admin/agente padrão sempre podem; funções personalizadas
//     só com a permissão específica.
// Espelha o padrão `moduleAllowed` do Sidebar (feature_modules + checkPermissions).
export function useWhatsappCallAccess() {
  const { currentAccount } = useAccount();
  const { checkPermissions } = usePolicy();

  const moduleOn = key =>
    currentAccount.value?.feature_modules?.[key] !== false;

  const canReceiveAstracallCalls = computed(
    () =>
      moduleOn('astracall') &&
      checkPermissions(['administrator', 'agent', 'astracall_calls_receive'])
  );

  // Ligação WhatsApp OFICIAL via 360Dialog (Calling API). O canal já é gateado por
  // voice_enabled + CHANNEL_VOICE; aqui aplicamos o controle extra de módulo/permissão.
  const canReceiveWhatsapp360Calls = computed(
    () =>
      moduleOn('whatsapp_360_calls') &&
      checkPermissions(['administrator', 'agent', 'whatsapp_360_calls_receive'])
  );

  // canReceiveWavoipCalls fica de fora: a integração Wavoip foi removida no
  // 60504f52f. Devolvê-la aqui exportaria um computed que não existe mais.
  return {
    canReceiveAstracallCalls,
    canReceiveWhatsapp360Calls,
  };
}
